import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";

import { BaseContractController } from "../_baseDealController";
import { EntityService } from "../../services/entity-service";
import { ContractService } from "../../services/contract-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";
import { ModalService } from "../../services/modal-service";
import { SearchService } from "../../services/search-service";

export class DealAssetsController extends BaseContractController {
	static $inject = ["$scope", "$q", "$window", "$location", "$anchorScroll", "$interval", "simpleCache",
		"entityService", "contractService", "contractSharedDataService", "localCacheService",
		"notifyService", "eventService", "adminService", "aclService", "modalService", "searchService"];

	dealID: string;
	dealRecID: number;
	dealTemplateID: string;
	dealLevel: boolean;
	initialized: boolean;
	loadingAssets: boolean;                                                 // flag for loading indicator

	selectedSearchAssets: { [key: number]: boolean };                       // dictionary of selected assets from asset search modal
	selectedSearchAssetIDs: number[];                                       // recIDs for selected assets from asset search modal
	firstAmountCMDs: { [key: string]: Models.ICharacteristicMetaData[] };   // dictionary of first amount CMDs for amount display 

	assetRecIDHashList: string[];
	assetSearchModalOpen: boolean;                                          // open flag for asset search modal
	hasCmds: { [key: string]: boolean };
	locked: number;
	forceRefresh: boolean;
	templateGroupIDs: number[];
	assetUsageTemplates: { [assetTemplateID: string]: Models.ICharacteristicTemplate[] } = {};

	contractCurrencyCharData: Models.ICharDataValue;

	selectedUsages: Models.IUsageRelationshipPair[];
	contractUsages: Models.PagedEntities<Models.IUsageRelationshipPair>;

	headerCollapsed: { [headerID: string]: boolean };
	assetTemplateIDs: { [assetID: string]: number[] };
	templateNames: { [templateID: number]: string };

	canEdit: boolean;

	pagingOptions: Models.IPagingOptions;

	parentCharTypeID: number;
	childChartypeID: number;
	parentTemplateID: number;
	showColumns: string[];
	canCreate: boolean;
	allowMultiple: boolean;
	showAdvance: boolean;
	selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];

	canCopy: boolean;
	dealCatalogItemRelationships: Models.IEntityRelationship[];
	divID: number;
	pageCount: number;
	removeCatalogItemModalOpen: boolean;
	removingCatalogItem: Models.IEntitySearchDoc;
	relatedCatalogItemTitles: string[];
	contractEntityTitle: string;
	deleteCatalogItemListText: string;

	constructor(
		$scope: ng.IScope,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService,
		$interval: ng.IIntervalService,
		private simpleCache: ng.ICacheObject,
		entityService: EntityService,
		private contractService: ContractService,
		sharedData: ContractSharedDataService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private eventService: EventService,
		adminService: AdminService,
		private aclService: AclService,
		private modalService: ModalService,
		public searchService: SearchService) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.dealID = "";
		this.visibility = 1;
		this.initialized = false;
		this.selectedSearchAssets = {};
		this.selectedSearchAssetIDs = [];
		this.firstAmountCMDs = {};
		this.forceRefresh = false;

		this.assetRecIDHashList = [];
		this.assetSearchModalOpen = false;
		this.hasCmds = {};
		this.locked = 1;
		this.templateGroupIDs = [Consts.TemplateGroupIDs.IntellectualPropertyTemplateGroup];
		this.contractCurrencyCharData = null;

		this.selectedUsages = [];

		this.headerCollapsed = {};
		this.assetTemplateIDs = {};
		this.templateNames = {};

		this.canEdit = false;

		this.pagingOptions = {
			rows: 10,
			page: 1
		}

		this.parentCharTypeID = Consts.CharTypeIDs.transaction;
		this.parentTemplateID = 0;
		this.childChartypeID = Consts.CharTypeIDs.property;
		this.showColumns = [];
		this.canCreate = false;
		this.allowMultiple = false;
		this.showAdvance = true;
		this.selectedRecIdTitlePairs = [];
		this.canCopy = false;
		this.dealCatalogItemRelationships = [];
		this.divID = 0;
		this.removeCatalogItemModalOpen = false;
		this.relatedCatalogItemTitles = [];

		eventService.on(Consts.Events.ContractRefreshAll, () => {
			return this.RefreshAssets();
		});

		$scope.$watch(() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.charDatas : null, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.contractCurrencyCharData = Utils.CharUtil.GetCurrencyCharData(this.sharedData.contract.charDataCollection);
			}
		}, true);

		$scope.$watch(() => this.sharedData.contractAssets,
			(newValue, oldValue) => {
				if (newValue != oldValue) {

					this.assetRecIDHashList = [];
					this.assetTemplateIDs = {};
					this.templateNames = {};

					_.forEach(newValue.documents, (contractAsset) => {
						this.assetRecIDHashList.push(contractAsset.recordID.toString());
					});
				}
			}, true);

		$scope.$watch(
			() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				this.locked = newValue;
			});

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && newValue == "Done") {
				this.RefreshAssets().then(() => {
					this.RefreshValidation();
				});
			}
		});

		$scope.$watch(() => this.pagingOptions, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.RefreshAssets();
			}
		}, true);

		this.$scope.$watch(() => {
			if (this.dealID == null) {
				return null;
			} else {
				return this.dealID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.refreshContract(this.dealID);
					});
				}
			});
	}

	Init(contractID: string, dealLevel: boolean = false) {
		this.dealID = contractID;
		this.dealLevel = dealLevel;

		var split = Utils.IdBuilder.splitEntityID(this.dealID);

		this.divID = split.divID;
		this.dealRecID = split.recID;
		this.refreshContract(this.dealID);
		this.RefreshAssets();
		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Assets);
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
			});
	}

	/*
	 * Refresh Assets section of contract summary
	 */
	RefreshAssets(): ng.IPromise<any> {
		this.notifyService.startProgress();
		this.loadingAssets = true;

		return this.sharedData.RefreshAssets(this.dealID, this.pagingOptions)
			.then((result) => {
				if (this.sharedData.contractAssets.documents.length > 0) {
					this.pageCount = Math.ceil(result.numFound / this.pagingOptions.rows);

					var assetTemplatesFacets = this.sharedData.contractAssets.facetResults["template_meta"];
					var assetTemplateIDs: number[] = [];
					_.forEach(assetTemplatesFacets, t => {
						var templateID = _.parseInt(t.key.split('|')[1]);
						this.getAssociatedTemplatesDefaults(Consts.CharTypeIDs.property, templateID, Consts.CharTypeIDs.usage,
							Consts.CharTypeIDs.transaction, Consts.CharTypeIDs.property)
							.then((res) => {
								this.assetUsageTemplates[templateID] = res.associatedTemplates;
							});
					});

					var catalogItemRecIDs = _.map(this.sharedData.contractAssets.documents, c => c.recordID);
					this.contractService.getContractAssetRelationships(this.dealID, catalogItemRecIDs)
						.then((result) => {
							this.dealCatalogItemRelationships = [];
							this.dealCatalogItemRelationships = result;
						});
				}

				this.initialized = true;
			})
			.finally(() => {
				this.loadingAssets = false;
				this.notifyService.endProgress();
			});
	}

	/*
	 * Gets and caches associable child templates, especially for the nested Asset/usage/amount data
	 * @param parentCharTypeID charTypeID of parent entity
	 * @param parentTempalteID templateID of the parent entity
	 * @param childCharTypeID charTypeID of child entity
	 */
	private getAssociatedTemplatesDefaults(parentCharTypeID: number, parentTemplateID: number, childCharTypeID: number,
		relCharTypeID?: number, relChildCharTypeID?: number) {
		var deferred = this.$q.defer<Models.ITemplateDefaults>();
		// make a unique hash
		var key = "pc" + parentCharTypeID + "pt" + parentTemplateID + "cc" + childCharTypeID;
		// make a flag to prevent parallel requests
		var busyKey = key + "busy";
		var output = <Models.ITemplateDefaults>this.simpleCache.get(key);
		var busy = this.simpleCache.get(busyKey);
		if (output == null && busy == null) {
			this.simpleCache.put(busyKey, true);
			this.entityService.getAssociatedTemplatesDefaults(parentCharTypeID, parentTemplateID, childCharTypeID, relCharTypeID, relChildCharTypeID)
				.then((result) => {
					this.simpleCache.put(key, result);
					deferred.resolve(result);
				});
		} else if (output != null) {
			deferred.resolve(output);
		} else {
			deferred.reject();
		}
		return deferred.promise;
	}

	RefreshValidation() {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	CountVisibleChars(charDataCollection: Models.ICharDataCollection): number {
		if (charDataCollection != null) {
			return Utils.AclUtil.filterCMDsByRights(this.aclService.acls, charDataCollection.templateMetaData, Consts.AccessRight.Read).length;
			//return _(charDataCollection.templateMetaData.characteristicMetaDatas).filter((cmd) => cmd.visibilityIndicator >= this.visibility).valueOf().length;
		}
		return 0;
	}

	/*
	 * Opens AssetSearch modal
	 */
	SearchAssets() {
		this.assetSearchModalOpen = true;
		this.allowMultiple = true;
		this.showAdvance = true;
		this.selectedRecIdTitlePairs = [];
	}

	/*
	 * Associate selected Assets from Asset Search Modal
	 */
	AddAssets() {
		// get selected ids
		var assetIDs: number[] = [];
		if (this.selectedRecIdTitlePairs.length > 0) {
			this.selectedRecIdTitlePairs.forEach((recIDTitlePair) => {
				assetIDs.push(recIDTitlePair.key);
			});
		}
		if (assetIDs.length > 0) {
			// start progress bar
			this.notifyService.startProgress();

			// make rest call
			this.contractService.addContractAssets(this.dealID, assetIDs)
				.then((result) => {
					this.assetSearchModalOpen = false;
					this.progressJobID = result.jobID;
					this.jobTitle = result.jobTitle;
					this.showJobProgressStatus = true;
					this.selectedRecIdTitlePairs = [];
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			// notify no selected assets
			this.notifyService.notifyError("No Catalog Items were selected");
		}
	}


	ShowRemoveAsset(asset: Models.IEntitySearchDoc) {

		var contractRecID = Utils.IdBuilder.splitEntityID(this.dealID).recID;
		//Does the asset have any invoices for the deal?
		//Get the invoices for the deal
		this.removingCatalogItem = asset;
		this.entityService.getExistingCatalogItemsFromDealToInvoices(contractRecID, [this.removingCatalogItem.recordID])
			.then((result) => {
				var breakDelete: boolean = false;

				if (result.success) {
					breakDelete = _.any(result.data, r => r == this.removingCatalogItem.recordID);
				}
				else {
					breakDelete = true;
				}

				if (breakDelete) {
					this.$window.alert("Unable to delete this catalog item because there are one or more associated accounting records.");
					this.notifyService.endProgress();
					this.$scope.$broadcast(Consts.Events.NotifyDone);
					this.removingCatalogItem = undefined;
				}
				else {
					this.removingCatalogItem = asset;
					var assetTitle = asset.title;
					this.contractEntityTitle = this.sharedData.contract.record.title;
					this.deleteCatalogItemListText = assetTitle + " and related Catalog Items will be removed from any Rights, Tables and Amounts on this Deal.<br/> Are you sure you want to remove this association?"
					this.removeCatalogItemModalOpen = true;
				}
			});
	}

	/*
	 * Remove an asset from the contract
	 * @param asset the entity+chardata+relationship of the asset to be removed
	 */
	RemoveAsset() {
		this.notifyService.startProgress();
		var dealAssetRelationship = _.find(this.dealCatalogItemRelationships, r => r.childRecID == this.removingCatalogItem.recordID);
		this.contractService.removeContractAsset(this.dealID, dealAssetRelationship.relRecID)
			.then((result) => {
				this.notifyService.notifySuccess("Catalog Item Removed");
				this.contractEntityTitle = "";
				this.deleteCatalogItemListText = "";
				this.removeCatalogItemModalOpen = false;
				return this.RefreshAssets();
			}).finally(() => {
				this.RefreshValidation();
				this.notifyService.endProgress();
				this.$scope.$broadcast(Consts.Events.NotifyDone);
			});
	}

	ToggleOpen(headerID: string) {
		this.headerCollapsed[headerID] = !(!!(this.headerCollapsed[headerID]));
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.contractService.deleteContract(this.dealID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
				() => {
					this.notifyService.notifyError("Error Deleting Deal");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	GetRelationshipID(assetRecordID: number) {
		var dealCatalogItemRel = _.find(this.dealCatalogItemRelationships, r => r.childRecID == assetRecordID);
		if (!_.isEmpty(dealCatalogItemRel)) {
			return Utils.IdBuilder.buildEntityID(this.divID, Consts.CharTypeIDs.relationship, dealCatalogItemRel.relRecID);
		}
		else { return ""; }
	}

	RefreshAll(): ng.IPromise<any> {
		var promises = [];
		promises.push(this.RefreshAssets());
		promises.push(this.refreshContract(this.dealID));
		promises.push(this.RefreshValidation());

		return this.$q.all(promises);
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	private refreshContract(contractId: string): ng.IPromise<void> {
		return this.sharedData.RefreshContract(contractId).then(() => {
			this.parentTemplateID = this.sharedData.contract.record.templateID;
		});
	}
}
